<template>
  <div class="moreMsg">
    <Nav :title="title" :back="back"></Nav>
    <div class="loading" v-if="isLoad">
      <img src="./../../assets/takingCar/loading.gif" alt="" />
    </div>
    <div class="content" :class="{ isIosx: isiOSX }" v-if="!isLoad">
      <p class="title">
        <span>{{ data.platform_name }}{{ data.car_type_name }}</span>
        <span>{{ time.substring(0, 10) }}</span>
      </p>
      <p v-for="(item, index) in data.prices" :key="index">
        <span>{{ item.chargeDesc }}</span>
        <span>{{ (item.amount / 100) | moneyFormat }}元</span>
      </p>
      <p v-if="type == 2&&orderDetail.deduct_coin!='0.00'" style="color:#F9591B;">
        <span>红包抵扣</span>
        <span>{{ data.deduct_coin | moneyFormat }}</span>
      </p>
      <p v-if="orderDetail.deduct_balance!='0.00'" style="color:#F9591B;">
        <span>个人余额抵扣</span>
        <span>{{ orderDetail.deduct_balance | moneyFormat }}元</span>
      </p>
      <p class="moneytotal" v-if="type == 2">
        <span>费用合计</span>
        <span>{{ external_total_money | moneyFormat }}元</span>
      </p>
    </div>
    <div class="estimate" v-if="!isLoad">
      <p v-if="type == 1">
        预计支付费用
        <span>{{ data.estimate_price | moneyFormat }}</span> 元
      </p>
      <p v-if="type == 2&&orderDetail.deduct_coin!='0.00'">
        支付费用
        <span>{{ data.estimate_price | moneyFormat }}</span> 元
        <span class="refund" v-if="orderDetail.is_refund == 20">已退红包：-{{orderDetail.refund.refund_coin}}</span>
        <span class="refund" v-if="orderDetail.is_refund == 20">已退款：-{{orderDetail.refund.refund_money}}元</span>
      </p>
        <p v-if="orderDetail.deduct_balance!='0.00'">
        支付费用
        <span>{{ data.estimate_price | moneyFormat }}</span> 元
        <span class="refund" v-if="orderDetail.is_refund == 20">已退个人余额：-{{orderDetail.refund.refund_balance}}</span>
        <span class="refund" v-if="orderDetail.is_refund == 20">已退款：-{{orderDetail.refund.refund_money}}元</span>
      </p>
    </div>
    <div class="tip" v-if="type == 1 && !isLoad">
      <p>
        预估价是根据实时交通状况、预计行驶里程、时间等因素估算得出，存在波动，仅供参考。高速费、停车费附加费用不包含在预估费用中，以司机实际支付为准。
      </p>
    </div>
    <div
      class="tip"
      v-if="type == 2 && data.short_name == 'YangGuang' && !isLoad"
    >
      <p>
        根据阳光出行平台规定，费用中<span>除客运服务费之外</span>的费用（<span>如停车费和高速费等</span>）不支持开具电子发票。
      </p>
      <p>
        若要开具该项费用的发票，您可以与司机师傅沟通，<span>自行保存纸质发票</span>。
      </p>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "预估车费明细",
      isiOSX: false,
      carName: "曹操新能源",
      time: "2020-03-13",
      data: {},
      type: 1,
      external_total_money: "0",
      taxis_order_sn: "taxis_2007291127508524",
      back: 0,
      isLoad: true,
      orderDetail:{}
    };
  },
  components: { Nav },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log(to);
      // console.log(from)
      if (from.path == "/takingCar/allCarType") {
        vm.back = 0;
      } else {
        vm.back = 1;
      }
    });
  },
  filters: {
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.judgeForward();
  },
  methods: {
    // 判断是否是预约价格明细
    judgeForward() {
      if (this.$route.query.type == "all") {
        // console.log("预估车费明细");
        // console.log(JSON.parse(this.$route.query.item));
        // console.log(this.$route.query.duration_time);
        this.isLoad = false;
        this.title = "预估车费明细";
        this.type = 1;
        this.data = JSON.parse(this.$route.query.item);
        this.time = this.$route.query.duration_time;
        // console.log(this.data)
      } else {
        // console.log("车费明细");
        this.taxis_order_sn = this.$route.query.taxis_order_sn;
        this.title = "车费明细";
        this.type = 2;
        this.getMoneyDetail();
      }
    },
    // 获取价格明细
    getMoneyDetail() {
      this.$api.setToken(this.$route.query.token);
      this.$api
        .post("/taxis/member/order/mine/detail", {
          taxis_order_sn: this.taxis_order_sn,
        })
        .then((res) => {
          // console.log(res);
          this.isLoad = false;
          this.orderDetail = res;
          this.time = res.created_at;
          this.data.estimate_price = res.pay_money;
          this.data.platform_name = res.platform.platform_name;
          this.data.short_name = res.platform.short_name;
          this.data.car_type_name = res.car_type_name;
          this.data.prices = JSON.parse(res.fixed_price_json);
          this.external_total_money = res.external_total_money;
          this.data.deduct_coin = res.deduct_coin;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.dialog {
  .van-dialog__content {
    color: #333333;
    font-size: 14px;
    line-height: 23px;
    p {
      span {
        color: #f9591b;
      }
    }
    p:last-child {
      margin-top: 10px;
    }
  }
}
.moreMsg {
  background: #ffffff;
  height: 100%;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .content {
    margin: 70px 15px 0;
    padding-top: 15px;
    p {
      color: #333333;
      font-size: 15px;
      line-height: 21px;
      overflow: hidden;
      margin-bottom: 15px;
      span:nth-child(n) {
        float: left;
      }
      span:nth-child(2n) {
        float: right;
      }
    }
    .title {
      margin: 15px 0;
      padding-bottom: 15px;
      border-bottom: 1px solid #eeeeee;
      span:nth-child(1) {
        font-size: 17px;
        line-height: 24px;
        font-weight: bolder;
      }
    }
    .moneytotal {
      margin: 15px 0;
      padding-bottom: 15px;
      padding-top: 15px;
      border-bottom: 1px solid #eeeeee;
      border-top: 1px solid #eeeeee;
      font-size: 17px;
      line-height: 24px;
      font-weight: bolder;
    }
    .allmoney {
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      padding: 15px 0;
      font-weight: bold;
    }
  }
  .estimate {
    margin: 5px 15px 30px;
    overflow: hidden;
    p {
      color: #333333;
      font-size: 15px;
      line-height: 21px;
      float: right;
      span {
        font-weight: bolder;
        font-size: 25px;
        line-height: 21px;
      }
      .refund{
      color: #F9591B;
      font-size: 14px;
      line-height: 20px;
      font-weight: normal;
      display: block;
      text-align: right;
      margin-top: 5px;
    }
    }
  }
  .tip {
    margin: 0 15px;
    p {
      color: #999999;
      font-size: 14px;
      line-height: 25px;
      span {
        color: #f9591b;
      }
    }
  }
  .isIosx {
    margin: 90px 15px 0;
  }
}
</style>
